module.exports = __webpack_public_path__ + "img/1896 - Plessy v Ferguson.70c21c18.jpg";